import React, { useEffect, useState } from "react";
import { acceptOffer, fetchOfferDetails } from "../../store";
import { useParams } from "react-router-dom";
import { useThunk } from "../../hooks/useThunk";
import { useSelector } from "react-redux";
import { formatYYYY_MM_DD } from "../../utils/dateFormating";
import { Loader } from "lucide-react";
import showToast from "../../utils/toastNotifications";
import { currencyFormatter } from "../../utils/formatting";
import { offerStatus, paymentMetrics } from "../../constants/commonConstants";
import Button from "../../components/Form/CustomButton";
import ActionLoader from "../../components/Common/ActionLoader";
import ErrorDisplay from "../../error/ErrorDisplay";

function Checkout() {
  const { offerId, thredId } = useParams();
  const { user } = useSelector((state) => state.auth);

  // thunks
  const [doFetchOffer, isFetchingOffer, fetchingOfferError] =
    useThunk(fetchOfferDetails);
  const [doAcceptOffer, isAcceptOffer, errorAcceptOffer] =
    useThunk(acceptOffer);

  const [offer, setOffer] = useState(null);

  // fetch offer details
  useEffect(() => {
    if (offerId) {
      fetchOffer();
    }
  }, [offerId]);

  const fetchOffer = async () => {
    const response = await doFetchOffer(offerId);
    if (response?.success) {
      const offerData = response?.response?.data;
      setOffer(offerData);
    } else {
      showToast("error" , response?.error?.message || "Error Occured");
    }
  };

  // FUNCTION: user accept the offer
  const handleProceedPayment = async () => {
    const response = await doAcceptOffer({
      thread: thredId,
      offer: offerId,
      user: user?._id,
    });
    if (response?.success) {
      const paymentUrl = response?.response?.data?.data?.authorization_url;
      
      if (paymentUrl) {
        window.location.href = paymentUrl; // Redirect user to payment page
      } else {
        showToast("error", "Payment URL not found");
      }
    } else {
      showToast("error", response?.error?.message || "Error Occured");
    }
  };

  const serviceFeeCalculation = (amount) => {
    if (amount === 0) {
      return 0;
    } else if (amount < paymentMetrics.boundaryAmount) {
      return paymentMetrics.flatFee;
    } else {
      return amount * (paymentMetrics.clientFee / 100);
    }
  };

  const offerAmount = currencyFormatter.format(offer?.amount || 0);
  const serviceFee =  serviceFeeCalculation(offer?.amount || 0);
  const formattedServiceFee = currencyFormatter.format(serviceFee);
  const total = currencyFormatter.format(serviceFee + offer?.amount || 0);

  return (
    <>
      {isFetchingOffer ? (
        <Loader />
      ) : fetchingOfferError ? (
        <ErrorDisplay
          errorMessage={fetchingOfferError?.message || "An error occured"}
          buttonText="Go Back"
          onClick={() => window.history.back()}
        />
      ) : (
        <div className="main-container p-4 md:my-[70px] md:mx-[100px] flex flex-col lg:flex-row justify-between gap-6 lg:gap-[20px]">
          <div className="left-container flex flex-col lg:w-[710px] w-full">
            <div className="top flex flex-col justify-center items-center gap-[8px] px-2">
              <p className="text-center text-primary font-inter text-xl md:text-[1.5rem] font-bold">
                Check Out
              </p>
              <p className="text-center font-inter text-sm md:text-[14px] font-normal text-[#535862]">
                Thank you for choosing JumaConnect! You are hiring a service
                provider and making a payment for the selected service. Please
                review the offer details before proceeding with the payment.
              </p>
            </div>
            <div className="bottom mt-6 md:mt-[24px] flex flex-col">
              <div className="p-4 md:p-[17px] flex flex-col">
                <div className="Order-Details">
                  <div className="pb-[11px] border-b-[1px] border-[#E7E9EB] font-inter font-medium text-base md:text-[16px] text-[#0F161E]">
                    Order Details
                  </div>
                  <div className="flex flex-col gap-[12px] mt-[20px]">
                    <div className="flex flex-col gap-2 md:flex-row md:justify-between md:gap-0">
                      <p className="font-inter font-normal text-sm md:text-[1rem] text-[#696969]">
                        Job Title
                      </p>
                      <p className="font-inter font-semibold text-sm md:text-[1rem] text-[#4A4A4A]">
                        {offer?.title || ""}
                      </p>
                    </div>
                    <div className="flex flex-col gap-2 md:flex-row md:justify-between md:gap-0">
                      <p className="font-inter font-normal text-sm md:text-[1rem] text-[#696969]">
                        Job Date
                      </p>
                      <p className="font-inter font-normal text-sm md:text-[1rem] text-[#696969]">
                        {formatYYYY_MM_DD(offer?.createdAt) || ""}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="Service Provider Details mt-[40px] flex flex-col">
                  <div className="pb-[11px] border-b-[1px] border-[#E7E9EB] font-inter font-medium text-base md:text-[16px] text-[#0F161E]">
                    Service Provider Details
                  </div>
                  <div className="flex flex-col gap-[12px] mt-[20px]">
                    <div className="flex flex-col gap-2 md:flex-row md:justify-between md:gap-0">
                      <p className="font-inter font-normal text-sm md:text-[1rem] text-[#696969]">
                        Service Pro Name
                      </p>
                      <p className="font-inter font-semibold text-sm md:text-[1rem] text-[#4A4A4A]">
                        {`${offer?.sender?.firstName} ${offer?.sender?.lastName}`}
                      </p>
                    </div>
                    {/* <div className="flex flex-col gap-2 md:flex-row md:justify-between md:gap-0">
                      <p className="font-inter font-normal text-sm md:text-[1rem] text-[#696969]">
                        Service Pro Level
                      </p>
                      <p className="font-inter font-normal text-sm md:text-[1rem] text-[#696969]">
                        {`Level ${offer?.sender?.level} Seller`}
                      </p>
                    </div> */}
                    {/* <div className="flex flex-col gap-2 md:flex-row md:justify-between md:gap-0">
                      <p className="font-inter font-normal text-sm md:text-[1rem] text-[#696969]">
                        Email Address
                      </p>
                      <p className="font-inter font-normal text-sm md:text-[1rem] text-[#696969]">
                        {offer?.sender?.email || ""}
                      </p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="right-container lg:w-[500px] p-4 md:px-[58px] md:py-[40px] bg-white rounded-[20px] border-[1px] border-[#CBD5E0]">
            <div className="container flex flex-col inner">
              {/* <div className="flex flex-row gap-4 md:gap-[20px] justify-center items-center"> */}
              {/* <div className="">
                <img src={ImageNew} alt="jd" className="w-20 md:w-auto" />
              </div> */}
              <div className="flex flex-col gap-[0.75rem]">
                <p className="font-inter text-sm md:text-[1rem] font-semibold text-[#4A4A4A]">
                  {offer?.title || ""}
                </p>
                <p className="font-inter text-base md:text-[1.125rem] font-bold text-[#000000]">
                  {offerAmount}
                </p>
              </div>
              {/* </div> */}
              <div className="Payment-Details my-6 md:my-[24px] flex flex-col">
                <div className="pb-[11px] border-b-[1px] border-[#E7E9EB] font-inter font-medium text-base md:text-[16px] text-[#0F161E]">
                  Payment Details
                </div>
                <div className="mt-[20px] gap-[8px] flex flex-col">
                  <div className="flex flex-row justify-between">
                    <p className="font-inter font-normal text-sm md:text-[16px] text-[#4A4A4A]">
                      Offer Amount
                    </p>
                    <p className="font-inter font-normal text-sm md:text-[16px] text-[#4A4A4A]">
                      {offerAmount}
                    </p>
                  </div>
                  <div className="flex flex-row justify-between">
                    <p className="font-inter font-normal text-sm md:text-[16px] text-[#4A4A4A]">
                      Service Fee
                    </p>
                    <p className="font-inter font-normal text-sm md:text-[16px] text-[#4A4A4A]">
                      {formattedServiceFee}
                    </p>
                  </div>
                  <div className="pt-[11px] border-t-[1px] border-[#E7E9EB] font-inter font-medium text-base md:text-[16px] text-[#4A4A4A] flex flex-row justify-between">
                    <p>Total</p>
                    <p>{total}</p>
                  </div>
                </div>
              </div>
              <div className="button mt-6 lg:mt-[48px] gap-[12px] flex flex-col">
                <Button
                  buttonText="Proceed Payment"
                  loading={isAcceptOffer}
                  className="text-sm font-inter md:text-base"
                  loaderColor="white"
                  onClick={handleProceedPayment}
                  disabled={offer?.status !== offerStatus.PENDING}
                />
                <button
                  className="bg-transparent rounded-[8px] flex justify-center items-center py-3 md:py-[16px] text-primary font-inter font-medium text-sm md:text-base"
                  onClick={() => window.history.back()}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* show loader while data process */}
      {isAcceptOffer && (
        <ActionLoader message="Processing Payment..." loaderColor="#FBC948" />
      )}
    </>
  );
}

export default Checkout;
